import { ReactElement } from 'react';

import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';
import IconChecked from 'components/icons/checked';
import IconCross from 'components/icons/cross';
import IconDash from 'components/icons/dash';
import IconRefresh from 'components/icons/refresh';

import { CryptoPayoutStatus } from 'types/cryptoPayout';

import { statusToLabelMap } from './keys';
import { BadgeContent } from './styles';

interface CryptoPayoutStatusBadgeProps {
  status: CryptoPayoutStatus;
}

const badgeToIconMap: Record<CryptoPayoutStatus, ReactElement | null> = {
  [CryptoPayoutStatus.Initiated]: <IconRefresh />,
  [CryptoPayoutStatus.Pending]: <IconRefresh />,
  [CryptoPayoutStatus.Submitted]: <IconRefresh />,
  [CryptoPayoutStatus.Confirmed]: <IconChecked />,
  [CryptoPayoutStatus.Completed]: <IconChecked />,
  [CryptoPayoutStatus.Canceled]: <IconCross />,
  [CryptoPayoutStatus.Failed]: <IconCross />,
};

const badgeTypeMap: Record<CryptoPayoutStatus, BadgeType> = {
  [CryptoPayoutStatus.Initiated]: BadgeType.Default,
  [CryptoPayoutStatus.Pending]: BadgeType.Default,
  [CryptoPayoutStatus.Submitted]: BadgeType.Default,
  [CryptoPayoutStatus.Confirmed]: BadgeType.Success,
  [CryptoPayoutStatus.Completed]: BadgeType.Success,
  [CryptoPayoutStatus.Canceled]: BadgeType.Fail,
  [CryptoPayoutStatus.Failed]: BadgeType.Fail,
};

export const CryptoPayoutStatusBadge = ({ status }: CryptoPayoutStatusBadgeProps) => {
  const { type, label } = statusToLabelMap[status];
  const icon = badgeToIconMap[type];
  const badgeType = badgeTypeMap[type];

  const usedLabel = label || <IconDash />;

  return (
    <Badge type={badgeType}>
      <BadgeContent>
        {icon}
        {usedLabel}
      </BadgeContent>
    </Badge>
  );
};
